/* OU VIVENT LES DATAPACKS TERRAIN 3D.
 *
 * Ces fichiers ne sont plus embarques dans le build : un territoire pese ~10 Mo
 * et ils sont desormais publies sur l'Object Storage (cf.
 * api/experiments/terrain3d/publish_datapack.py). Ce module est le SEUL endroit
 * qui sait ou les chercher — six appels les lisaient auparavant chacun avec son
 * propre `${process.env.PUBLIC_URL}/terrain3d`, ce qui garantissait qu'un jour
 * l'un d'eux serait oublie lors d'un changement d'hebergement.
 *
 * LE REPLI EST VOLONTAIRE. Sans REACT_APP_TERRAIN_BASE_URL, on retombe sur
 * front/public/terrain3d : le pipeline ecrit toujours la, donc un poste de dev
 * sans acces reseau (ou sans identifiants Scaleway) continue de travailler sur
 * les datapacks locaux. C'est aussi ce qui fait qu'un `npm start` fraichement
 * clone ne se retrouve pas avec une carte vide sans explication.
 *
 * LA VERSION EST DANS L'URL, pas dans le code : la variable pointe sur
 * .../terrain3d/v1. Les objets sont servis avec un cache d'un an, donc corriger
 * un datapack deja publie impose de bumper ce segment (v2) des deux cotes —
 * script de publication et variable d'environnement. Un cache d'un an sur une
 * URL stable rendrait la correction invisible pendant des mois.
 *
 * Rappel CRA : seules les variables prefixees REACT_APP_ arrivent au navigateur,
 * et leur valeur est figee AU BUILD. Changer la base en production suppose donc
 * un redeploiement du front, pas seulement une modification de la config.
 */

const configured = (process.env.REACT_APP_TERRAIN_BASE_URL || "").trim();

// Le slash final est retire une fois ici plutot que d'exiger des six appelants
// qu'ils s'accordent sur la presence ou non d'un separateur.
export const TERRAIN_BASE_URL = configured
  ? configured.replace(/\/+$/, "")
  : `${process.env.PUBLIC_URL}/terrain3d`;

/** Catalogue des territoires disponibles. Charge avant tout choix de carte. */
export const TERRITORIES_URL = `${TERRAIN_BASE_URL}/territories.json`;

/** Dossier d'un territoire : `${territoryUrl(id)}/rivers.json`, etc. */
export function territoryUrl(territoryId) {
  return `${TERRAIN_BASE_URL}/${territoryId}`;
}

/** Vrai si les datapacks viennent du stockage distant et non du build local. */
export const TERRAIN_IS_REMOTE = Boolean(configured);
